<template>
	<nav class="InPageNav" >
		<ul>
			<li v-for="(option,i) in options" :key="i" ><router-link :to="{path:option.path}" >{{ option.text }}</router-link></li>
		</ul>
	</nav>
</template>

<script>

	export default {

		props:[
			'options',
		],

		watch : {
			'$route.path' : function(){
				this.open = false;
			}
		},
	}

</script>